import { DateTime } from 'luxon'
import React from 'react'

export const Timestamp = ({ date }: { date: any }) => {
  switch (typeof date) {
    case 'number':
      return <span>{DateTime.fromMillis(date).toRelative()}</span>
    case 'string':
      return <span>{DateTime.fromISO(date).toRelative()}</span>
    default:
      return <></>
  }
}
